import { Button } from 'bricks-ui/packages/bricks-ui';

export default Button;
